/** @jsx jsx */
import { ReactNode } from 'react';

import { css, jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';

import { displayFontStack } from '../shared';

const styleMap = {
  h900: css({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage-spacing
    fontFamily: displayFontStack,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage-spacing
    fontSize: '52px',
    fontWeight: token('font.weight.regular', '400'),
  }),
  h800: css({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage-spacing
    fontFamily: displayFontStack,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage-spacing
    fontSize: '36px',
    fontWeight: token('font.weight.regular', '400'),
  }),
};

interface HeroHeadingProps {
  level: 'h900' | 'h800';
  testId?: string;
  children: ReactNode;
}

/**
 * __Hero heading__
 *
 * A hero heading renders a large heading to display at the top of a page.
 *
 */
const HeroHeading = ({ level, testId, children }: HeroHeadingProps) => {
  const headingLevelStyles = styleMap[level];

  return (
    <h1 data-testid={testId} css={headingLevelStyles}>
      {children}
    </h1>
  );
};

export default HeroHeading;
